export default {
      id: "ic-bahis-yap-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-bahis-yap-usage",
      toString: function () {
        return this.url;
      }
    }